import { LoaderService } from '@/app/common/services/loader/loader.service'
import { ChecklistHeaderService } from '@/app/modules/checklist-header/core/service'
import {
  ChecklistHeader,
  HeaderTypeEnum
} from '@/app/modules/checklist-header/core/type'
import { CommonModule } from '@angular/common'
import { Component, EventEmitter, inject, Output } from '@angular/core'
import {
  ReactiveFormsModule,
  FormsModule,
  FormGroup,
  FormControl,
  Validators
} from '@angular/forms'
import { MatIconModule } from '@angular/material/icon'
import { NzButtonModule } from 'ng-zorro-antd/button'
import { NzFormModule } from 'ng-zorro-antd/form'
import { NzInputModule } from 'ng-zorro-antd/input'
import { NzModalModule } from 'ng-zorro-antd/modal'
import { NzNotificationService } from 'ng-zorro-antd/notification'
import { NzSelectModule } from 'ng-zorro-antd/select'
import { NzUploadModule } from 'ng-zorro-antd/upload'
import { BehaviorSubject } from 'rxjs'

@Component({
  selector: 'app-edit-header',
  standalone: true,
  imports: [
    CommonModule,
    NzButtonModule,
    MatIconModule,
    ReactiveFormsModule,
    FormsModule,
    NzFormModule,
    NzInputModule,
    NzModalModule,
    NzSelectModule,
    NzUploadModule
  ],
  templateUrl: './edit-header.component.html',
  styleUrl: './edit-header.component.scss'
})
export class EditHeaderComponent {
  @Output() onHeaderEdited = new EventEmitter<boolean>()
  heaaderLoader = new BehaviorSubject<boolean>(false)

  private loaderService = inject(LoaderService)
  private notification = inject(NzNotificationService)
  private checklistHeaderService = inject(ChecklistHeaderService)

  data!: ChecklistHeader
  isVisible = false
  checklistType!: HeaderTypeEnum

  headerForm = new FormGroup({
    chassis: new FormControl<string>('', [Validators.required]),
    hours_meter: new FormControl<number>(0, [Validators.required]),
    maintenance_observation: new FormControl<string>(''),
    client_name: new FormControl<string>('', [Validators.required]),
    client_email: new FormControl<string>('', [
      Validators.required,
      Validators.email
    ]),
    client_phone: new FormControl<string>('', [
      Validators.required,
      Validators.minLength(10)
    ])
  })

  handleOpen (data: any) {
    if (!data) return
    this.data = data
    this.checklistType = data.type
    this.isVisible = true

    const isAuction = this.checklistType === HeaderTypeEnum.AUCTION
    const clientControls = ['client_name', 'client_email', 'client_phone']

    clientControls.forEach(name => {
      const control = this.headerForm.get(name)
      isAuction ? control?.enable() : control?.disable()
    })

    this.headerForm.patchValue({
      chassis: data.chassis,
      hours_meter: data.hours_meter,
      maintenance_observation: data.maintenance_observation,
      client_name: data.client_name || '',
      client_email: data.client_email || '',
      client_phone: data.client_phone || ''
    })
  }

  onSubmit () {
    if (this.headerForm.valid) {
      this.heaaderLoader.next(true)
      const formData = this.headerForm.value

      this.loaderService
        .executeWithLoader(
          this.checklistHeaderService.update(this.data.id, formData as any)
        )
        .subscribe({
          next: () => {
            this.heaaderLoader.next(false)
            this.notification.success(
              'Sucesso',
              'Cabeçalho atualizado com sucesso!'
            )
            this.isVisible = false
            this.onHeaderEdited.emit(true)
          },
          error: () => {
            this.heaaderLoader.next(false)
            this.notification.error(
              'Erro',
              'Erro não foi possivel alterar o cabeçalho!'
            )
          }
        })
    } else {
      Object.values(this.headerForm.controls).forEach(control => {
        if (control.invalid) {
          control.markAsDirty()
          control.updateValueAndValidity({ onlySelf: true })
        }
      })
      this.notification.error(
        'Erro',
        'Por favor, verifique os campos obrigatórios.'
      )
    }
  }

  handleCancel () {
    this.isVisible = false
  }
}
